import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { ITagAbstractClassArgument } from 'tag/ts/tag/interfaces/arguments/ITagAbstractClassArgument';

/**
 * @copyright © Paramount Streaming
 * @author Zeeshan Ahmad
 * @description Utility functions for VODFather feature
 */
export class VODFatherUtilities extends AbstractTagClass {

	constructor( argument: ITagAbstractClassArgument ) {
		super(
			{
				name: 'VODFatherUtilities',
				...argument
			}
		);
	}

	/**
	 * Returns boolean indicating whether VODFather flag is enabled in SmartTag params
	 * @param {IParamsVO} params
	 * @returns {boolean}
	 */
	hasFeatureFlag( params = this.tag?.params ): boolean {
		return params?.AD?.vodf === true;
	}

	/**
	 * Returns boolean indicating whether current asset is VOD
	 * @param {IParamsVO} params
	 * @param {IAPIMetadataItem} metadata
	 * @returns {boolean}
	 */
	isVOD( params = this.tag?.params, metadata = this.apiMetadata ): boolean {
		return !this.tag?.model?.contentUtilities?.isLive( params, metadata );
	}

	/**
	 * Returns boolean indicating whether VODFather logic should be executed
	 * @param {IParamsVO} params
	 * @param {IAPIMetadataItem} metadata
	 * @returns {boolean}
	 */
	isEnabled( params = this.tag?.params, metadata = this.apiMetadata ): boolean {
		return (
			this.isVOD( params, metadata ) &&
			this.hasFeatureFlag()
		);
	}

	/**
	 * Returns daiCmsId from millstone metadata within SmartTag params (if set)
	 * @param {IParamsVO} params
	 * @returns {string}
	 */
	getDaiCmsId( params = this.tag?.params ): string {
		return this.tag?.millstoneUtilities?.getDaiCmsId( params );
	}
}